import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GiftCardProvider from "./comps/store";
import ErrorBoundary from "./comps/error-boundary";
import ChatPage from './comps/screens/chatPage';
import './App.css';

// Lazy load components
const GiftcardHome = lazy(() => import("./comps/screens/giftcard-home"));


const Footer = () => {
    return <footer>&copy; Agantis 2024</footer>;
};

function App() {
    const brandName = window.location.hostname.split(".").slice(0, -1).join(" ");

    return (
        <ErrorBoundary>
            <GiftCardProvider>
                <div className={"giftcards " + brandName}>
                    <Router>
                        <Suspense fallback={<div>Loading...</div>}>
                            <Routes>
                                <Route path="/" element={<GiftcardHome />} />
                                 <Route path="/chat" element={<ChatPage />} />
                                <Route path="/:token" element={<GiftcardHome />} />
                                <Route path="/balance/:token" element={<GiftcardHome />} />
                            </Routes>
                        </Suspense>
                        <Footer />
                    </Router>
                </div>
            </GiftCardProvider>
        </ErrorBoundary>
    );
}

export default App;
